<template>
  <nav
    aria-label="menu"
    class="bg-surface-default-low fixed inset-0 z-20 flex flex-col md:hidden"
  >
    <NavBurgerMenuHeader @close="toggle" />
    <div
      v-if="isPostalCodePromiseEnabled"
      class="bg-surface-default-hi flex items-center justify-between px-24 py-8"
    >
      <CountrySwitchMenuFullScreen variant="chip" />
      <DeliveryPostalCodeModal entry-point="nav" />
    </div>
    <!-- eslint-disable-next-line tailwindcss/no-custom-classname -->
    <div class="flex-1 overflow-auto py-20 scrollable">
      <NavBurgerMenuItemList />
      <NavBurgerMenuFooter @click-item="toggle" />
    </div>
    <div
      v-if="!isPostalCodePromiseEnabled"
      class="border-static-default-low border-t px-20 py-12"
    >
      <CountrySwitchMenuFullScreen />
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import DeliveryPostalCodeModal from '~/scopes/shipping/components/DeliveryPostalCodeModal/DeliveryPostalCodeModal.vue'

import { useBurgerMenuState } from '../../composables/useBurgerMenuState'
import CountrySwitchMenuFullScreen from '../CountrySwitch/CountrySwitchMenuFullScreen.vue'

import NavBurgerMenuFooter from './NavBurgerMenuFooter.vue'
import NavBurgerMenuHeader from './NavBurgerMenuHeader.vue'
import NavBurgerMenuItemList from './NavBurgerMenuItemList.vue'

const { toggle } = useBurgerMenuState()
const experiments = useExperiments()

const isPostalCodePromiseEnabled = computed(
  () => experiments['experiment.postalCodePromise'] === 'postalCodeEnabled',
)
</script>
